import { useSearch } from '../../hooks/context';

const useValuePropositionsDetails = () => {
  const { value_propositions_details, valuePropositionsDetailsHidden } = useSearch();

  if (!valuePropositionsDetailsHidden && value_propositions_details) {
    return value_propositions_details;
  }

  return null;
};

export default useValuePropositionsDetails;
